import createAttachmentFromUriOperation from 'owa-service/lib/operation/createAttachmentFromUriOperation';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import type { ClientItemId } from 'owa-client-ids';

export default function createAttachmentFromUri(
    parentItemId: ClientItemId,
    uri: string,
    name: string,
    subscriptionId: string,
    isInline: boolean,
    contentId: string
): Promise<string> {
    const requestOptions = getMailboxRequestOptions(parentItemId.mailboxInfo) || {};
    return createAttachmentFromUriOperation(
        {
            itemId: parentItemId,
            uri,
            name,
            subscriptionId,
            isInline,
            contentId,
        },
        requestOptions
    );
}
